import React, { useState } from 'react';
import { useInventory } from '../context/InventoryContext';
import { categories, units } from '../data/mockData';
import { Plus, Trash2, Edit3, AlertTriangle, X } from 'lucide-react';

export default function Products() {
  const { products, setProducts, editProduct, getStockReport } = useInventory();
  const report = getStockReport(new Date().toISOString().split('T')[0]);
  
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({ id: null, name: '', category: categories[0], unit: units[0], minLimit: 0, openingStock: 0 });

  const openAdd = () => {
    setFormData({ id: null, name: '', category: categories[0], unit: units[0], minLimit: 0, openingStock: 0 });
    setIsModalOpen(true);
  };

  const openEdit = (p) => {
    setFormData({ ...p });
    setIsModalOpen(true);
  };

  const saveProduct = (e) => {
    e.preventDefault();
    if(formData.id) { editProduct(formData); } 
    else { setProducts([{ ...formData, id: Date.now() }, ...products]); }
    setIsModalOpen(false);
  };

  const deleteProduct = (id) => {
    if(window.confirm("حذف الصنف نهائياً؟")) setProducts(products.filter(p => p.id !== id));
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-bold">دليل الأصناف</h2>
        <button onClick={openAdd} className="bg-slate-800 text-white px-4 py-2 rounded-lg flex items-center gap-2 font-bold"><Plus size={20} /> إضافة صنف جديد</button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        {report.map(prod => (
          <div key={prod.id} className="bg-white p-5 rounded-xl border shadow-sm relative">
            <div className="flex justify-between items-start mb-4">
              <div><span className="text-xs bg-slate-100 px-2 py-1 rounded text-slate-600">{prod.category}</span><h3 className="text-lg font-bold mt-1">{prod.name}</h3></div>
              <div className="flex gap-2">
                <button onClick={() => openEdit(prod)} className="text-slate-400 hover:text-blue-500"><Edit3 size={18} /></button>
                <button onClick={() => deleteProduct(prod.id)} className="text-slate-400 hover:text-red-500"><Trash2 size={18} /></button>
              </div>
            </div>
            <div className="bg-slate-50 p-3 rounded-lg text-center mb-2">
              <div className="text-xs text-slate-500">إجمالي المخزون</div>
              <div className="text-xl font-mono font-bold">{prod.totalStock} <span className="text-xs">{prod.unit}</span></div>
            </div>
            {prod.totalStock <= prod.minLimit && <div className="text-red-600 bg-red-50 p-2 rounded text-xs font-bold"><AlertTriangle size={14} className="inline" /> رصيد منخفض (الحد: {prod.minLimit})</div>}
          </div>
        ))}
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-xl w-full max-w-md p-6">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-bold">{formData.id ? 'تعديل صنف' : 'صنف جديد'}</h3>
              <button onClick={()=>setIsModalOpen(false)}><X className="text-slate-400 hover:text-red-500"/></button>
            </div>
            <form onSubmit={saveProduct} className="space-y-4">
              <div><label className="block text-sm font-bold mb-1">اسم الصنف</label><input required type="text" value={formData.name} onChange={e=>setFormData({...formData, name: e.target.value})} className="w-full border rounded p-2"/></div>
              <div className="grid grid-cols-2 gap-4">
                <div><label className="block text-sm font-bold mb-1">التصنيف</label><select value={formData.category} onChange={e=>setFormData({...formData, category: e.target.value})} className="w-full border rounded p-2">{categories.map(c=><option key={c}>{c}</option>)}</select></div>
                <div><label className="block text-sm font-bold mb-1">الوحدة</label><select value={formData.unit} onChange={e=>setFormData({...formData, unit: e.target.value})} className="w-full border rounded p-2">{units.map(u=><option key={u}>{u}</option>)}</select></div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div><label className="block text-sm font-bold mb-1">الحد الأدنى للتنبيه</label><input type="number" value={formData.minLimit} onChange={e=>setFormData({...formData, minLimit: Number(e.target.value)})} className="w-full border rounded p-2"/></div>
                {!formData.id && <div><label className="block text-sm font-bold mb-1">الرصيد الافتتاحي</label><input type="number" value={formData.openingStock} onChange={e=>setFormData({...formData, openingStock: Number(e.target.value)})} className="w-full border rounded p-2"/></div>}
              </div>
              <button type="submit" className="w-full bg-blue-600 text-white py-2 rounded font-bold hover:bg-blue-700">حفظ الصنف</button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
